<template lang="pug">
pEmbed(:urlProps="urlProps")
</template>

<script>
import pEmbed from '@/components/firebase'

export default {
  name: 'App',
  components: {
    pEmbed
  },
  props: {
    urlProps: {
      type: String,
      default: 'FCq9bg4c18ybcrHm9DQd'
    }
  }
};
</script>

<style>
@import '@/assets/playercustom.css';
</style>
